import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import WarningAmber from "@mui/icons-material/WarningAmber";
import { Box, Snackbar, SnackbarContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@/app/store";
import {
  NOTIFICATION_AUTO_HIDE_MS,
  NOTIFICATION_SNACKBAR_TOP_OFFSET_PX,
  NOTIFICATION_VARIANT,
} from "@/constants";
import { hideNotification } from "@/shared/notifications/model/notificationSlice";

export function AppSnackbar() {
  const dispatch = useAppDispatch();
  const open = useAppSelector((s) => s.notifications.open);
  const variant = useAppSelector((s) => s.notifications.variant);
  const messageKey = useAppSelector((s) => s.notifications.messageKey);
  const messageNs = useAppSelector((s) => s.notifications.messageNs);
  const { t } = useTranslation(messageNs);

  const isSuccess = variant === NOTIFICATION_VARIANT.SUCCESS;
  const palette = isSuccess ? "success" : "error";
  const Icon = isSuccess ? CheckCircleOutline : WarningAmber;

  return (
    <Snackbar
      open={open}
      autoHideDuration={NOTIFICATION_AUTO_HIDE_MS}
      onClose={() => dispatch(hideNotification())}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ top: `${NOTIFICATION_SNACKBAR_TOP_OFFSET_PX}px !important` }}
    >
      <SnackbarContent
        message={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Icon fontSize="small" sx={{ color: `${palette}.main` }} />
            <Typography
              variant="body2"
              sx={{ color: `${palette}.main`, fontWeight: 500 }}
            >
              {t(messageKey)}
            </Typography>
          </Box>
        }
        sx={{
          bgcolor: `${palette}.light`,
          boxShadow: (theme) => theme.shadows[4],
          "& .MuiSnackbarContent-message": {
            padding: 0,
          },
        }}
      />
    </Snackbar>
  );
}
